<script setup lang="ts">
    import { Swiper, SwiperSlide } from 'swiper/vue';

    declare interface TextSliderProps {
        data: TextSliderData;
        sequence: InfoBlockData[];
    }

    defineProps<TextSliderProps>();

    const { setMainSwiper } = useSlider();
</script>

<template>
    <mol-section
        :intro="data.intro"
        class="org-text-slider section-text-color overflow-hidden">
        <nuxt-error-boundary @error="() => {}">
            <swiper
                v-if="sequence && sequence.length > 0"
                class="overflow-visible!"
                :centered-slides="false"
                :slides-per-view="1"
                @swiper="setMainSwiper">
                <swiper-slide
                    v-for="(item, idx) in sequence"
                    :key="idx">
                    <div class="flex flex-col gap-5 text-center lg:m-auto lg:max-w-(--breakpoint-md)">
                        <atm-heading level="h3">{{ item.title }}</atm-heading>
                        <renderer-html
                            v-if="item.subtitle"
                            :content="item.subtitle" />
                    </div>
                </swiper-slide>
                <mol-slider-navigation />
            </swiper>
        </nuxt-error-boundary>
    </mol-section>
</template>
